import FormattedMessage from 'I18n/components/FormattedMessage';
import DataSourcePropertyName from 'automation-ui-formula-editor/data-sources/DataSourcePropertyName';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import DebugPropertyCard from 'automation-ui-canvas/components/panels/debugger-panel/DebugPropertyCard';
import I18n from 'I18n';
import { TestingMetaById } from 'automation-ui-canvas/components/panels/debugger-panel/constants/SingleActionTestingConstants';
import { useActionOutputFields } from 'automation-ui-canvas/queries/outputFieldsQuery';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionOutputsSection = ({
  actionId,
  actionTypeId,
  logEvent
}) => {
  var _logEvent$contextMap;
  let outputs = [];
  const {
    outputFieldsByName,
    loading
  } = useActionOutputFields({
    actionTypeId
  });
  const testingMeta = TestingMetaById[actionTypeId || ''];
  const aiGeneratedFields = (testingMeta === null || testingMeta === void 0 ? void 0 : testingMeta.aiGeneratedFields) || [];

  // Add error fields to the output fields by name
  const allFieldLabelsByName = Object.assign({}, outputFieldsByName, {
    hs_execution_state: I18n.text('debuggerPanel.step.askAiFields.hs_execution_state'),
    message: I18n.text('debuggerPanel.step.askAiFields.message'),
    hs_error_type: I18n.text('debuggerPanel.step.askAiFields.errorType')
  });
  outputs = ((logEvent === null || logEvent === void 0 || (_logEvent$contextMap = logEvent.contextMap) === null || _logEvent$contextMap === void 0 ? void 0 : _logEvent$contextMap.ACTION_OUTPUT_VALUES) || []).map(output => {
    const token = `{{ action_outputs.action_output_${actionId}.${output.fieldKey} }}`;
    return Object.assign({
      isAiGenerated: aiGeneratedFields.includes(output.fieldKey)
    }, output, {
      token,
      label: /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "debuggerPanel.step.outputs.outputNameTooltip",
          options: {
            name: output.fieldKey
          }
        }),
        children: /*#__PURE__*/_jsx("span", {
          children: loading ? /*#__PURE__*/_jsx(SkeletonText, {}) : allFieldLabelsByName[output.fieldKey] ? allFieldLabelsByName[output.fieldKey] : /*#__PURE__*/_jsx(DataSourcePropertyName, {
            token: token
          })
        })
      }),
      value: output.value
    });
  });
  if (outputs.length === 0) {
    outputs = [{
      token: null,
      label: I18n.text('debuggerPanel.step.noValue'),
      value: I18n.text('debuggerPanel.step.noValue'),
      isAiGenerated: false
    }];
  }
  return outputs.map(output => /*#__PURE__*/_jsx(DebugPropertyCard, {
    property: output.label,
    value: output.value,
    token: output.token,
    isAiGenerated: output.isAiGenerated
  }, output.token));
};
export default ActionOutputsSection;